import { FC, memo, useEffect } from "react";

import { Button, Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import MaskedInput from "react-input-mask";

import styles from "./CorrectionForm.module.scss";

import correctionToMask from "@/utils/correctionToMask";
import { ICorrection } from "@/models/Correction";

interface CorrectionFormProps {
  readonly: boolean;
  values: ICorrection | null;
  loading?: boolean;
  onSubmit?: (values: any) => void;
}

const defaultValues = {
  Tinh: 0,
  Rinh: 0,
  Rexh: 0,
  "%CO2inh": 0,
  "%CO2exh": 0,
  CO2V: 0,
  "Vent.V": 0,
};

const rules = [
  {
    required: true,
    message: "Please input the value",
  },
  {
    message: "Should be number",
    validator: (_: any, value: string) => {
      if (Number.isInteger(parseInt(value))) {
        return Promise.resolve();
      } else {
        return Promise.reject("Some message here");
      }
    },
  },
];

const CorrectionForm: FC<CorrectionFormProps> = ({
  values,
  readonly,
  loading,
  onSubmit,
}) => {
  const [form] = useForm();

  useEffect(() => {
    form.setFieldsValue(correctionToMask(values || defaultValues));
  }, [values, form]);

  return (
    <Form
      form={form}
      className={styles.form}
      hideRequiredMark
      disabled={readonly}
      name="calibration"
      labelCol={{ span: 12 }}
      onFinish={onSubmit}
    >
      <Form.Item
        label="Temperature of the inhalation"
        name="Tinh"
        rules={rules}
      >
        <MaskedInput disabled={readonly} mask="9.9999" maskChar="0">
          {
            // @ts-ignore
            (inputProps) => <Input {...inputProps} />
          }
        </MaskedInput>
      </Form.Item>

      <Form.Item label="Resistance of the inhalation" name="Rinh" rules={rules}>
        <MaskedInput disabled={readonly} mask="9.9999" maskChar="0">
          {
            // @ts-ignore
            (inputProps) => <Input {...inputProps} />
          }
        </MaskedInput>
      </Form.Item>

      <Form.Item label="Resistance of the exhalation" name="Rexh" rules={rules}>
        <MaskedInput disabled={readonly} mask="9.9999" maskChar="0">
          {
            // @ts-ignore
            (inputProps) => <Input {...inputProps} />
          }
        </MaskedInput>
      </Form.Item>

      <Form.Item
        label="CO₂ volume of the inhalation"
        name="%CO2inh"
        rules={rules}
      >
        <MaskedInput disabled={readonly} mask="9.9999" maskChar="0">
          {
            // @ts-ignore
            (inputProps) => <Input {...inputProps} />
          }
        </MaskedInput>
      </Form.Item>

      <Form.Item
        label="CO₂ volume of the exhalation"
        name="%CO2exh"
        rules={rules}
      >
        <MaskedInput disabled={readonly} mask="9.9999" maskChar="0">
          {
            // @ts-ignore
            (inputProps) => <Input {...inputProps} />
          }
        </MaskedInput>
      </Form.Item>

      <Form.Item
        label="СО₂ supply"
        name="CO2V"
        rules={[
          {
            required: true,
            message: "Please input the value",
          },
        ]}
      >
        <MaskedInput disabled={readonly} mask="9.9999" maskChar="0">
          {
            // @ts-ignore
            (inputProps) => <Input {...inputProps} />
          }
        </MaskedInput>
      </Form.Item>

      <Form.Item label="Lung ventilation" name="Vent.V" rules={rules}>
        <MaskedInput disabled={readonly} mask="9.9999" maskChar="0">
          {
            // @ts-ignore
            (inputProps) => <Input {...inputProps} />
          }
        </MaskedInput>
      </Form.Item>

      <Form.Item>
        <Button
          disabled={loading}
          loading={loading}
          className={styles.submit}
          htmlType="submit"
        >
          Save correction
        </Button>
      </Form.Item>
    </Form>
  );
};

export default memo(CorrectionForm);
